import React from 'react'
import { Helmet } from 'react-helmet-async'
import Contact from '@/components/main/contact'
import SeoMetaData from '@/components/SeoMetaData'
import { config } from '@/lib/config'
import ContactOnbizalomContent from '@/components/contact/ContactOnbizalomContent'

export default function ContactOnbizalom() {
  return (
    <>
      <Helmet>
        <title>Kapcsolat - Önbizalom | BeArt Művészetterápia</title>
        <meta name="description" content="Jelentkezés Önbizalom fejlesztő programra" />
        <link rel="canonical" href="https://beart.hu/kapcsolat/onbizalom" />
      </Helmet>
      
      <SeoMetaData
        seoTitle="Kapcsolat - Önbizalom | BeArt Művészetterápia"
        seoDescription="BeArt Művészetterápia, Art Coaching, családállítás, coaching, önismeret - művészetterápiás csoportok, egyéni és csoportos alkalmak, szervezeteknek kiégés megelőzés programok, önismereti foglalkozások"
      />
      
      <section className="mx-auto mb-8 mt-8 flex w-3/4 rounded-lg bg-[#ffcc99] bg-opacity-50 text-black shadow">
        <Contact
          title="Jelentkezés az Önbizalom fejlesztő programra"
          hidden="onbizalom"
          content={<ContactOnbizalomContent />}
        >
          <img
            src={`${config.basePath}/images/onbizalom.png`}
            alt="Önbizalom"
            width={"100%"}
          />
        </Contact>
      </section>
    </>
  )
}
